import React from 'react';
import MyAccountCard from './MyAccountCard';

interface PricingCsvExportWidgetProps {
    title?: string;
    description?: string;
    buttonLabel?: string;
    downloadUrl?: string;
}

const PricingCsvExportWidget: React.FC<PricingCsvExportWidgetProps> = ({
    title = 'My Pricing',
    description = 'Download your current pricing as a CSV file.',
    buttonLabel = 'Download CSV',
    downloadUrl = '',
}) => {
    const hasDownloadUrl = downloadUrl.trim() !== '';
    const resolvedButtonLabel = buttonLabel.trim() || 'Download CSV';

    return (
        <MyAccountCard
            slug="pricing-csv-export"
            title={title}
            subtitle={description}
            className="pricing-csv-export-widget"
        >
            {hasDownloadUrl ? (
                <a href={downloadUrl} className="btn btn-primary pricing-csv-export-widget__download">{resolvedButtonLabel}</a>
            ) : (
                <button type="button" className="btn btn-primary pricing-csv-export-widget__download" disabled>{resolvedButtonLabel}</button>
            )}
        </MyAccountCard>
    );
};

export default PricingCsvExportWidget;
